<template>
<div class="pdf">
    <!-- // 自己引入就可以使用,这里我的需求是做了分页功能,如果不需要分页功能,只要src就可以了 -->
    <!-- <pdf
      :src="pdfSrc"
      :page="currentPage"
      @num-pages="pageCount=$event"
      @page-loaded="currentPage=$event"
      @loaded="loadPdfHandler" >
    </pdf> -->
    <span class="load" v-show="loading" style="line-height: 88px;color: #666;font-size: 20px;width: 100%;text-align: center;margin-left:40%;">加载中...</span>
    <pdf
      v-show="!loading"
      v-for="i in numPages"
      :key="i"
      :page="i"
      :src="pdfUrl" style="width: 100vw; height: auto;" @num-pages="pageCount=$event">
    </pdf>
     <!-- status  0 免费 1 收费 2 已购 -->
    <!-- <div class="fixed_box" v-show="status == '1' && isShowMoney">
      <p>可试读30％，浏览完整版可以</p>
      <button class="btn" @click="goPay">
        <span class="small">¥</span>
        <span class="big">{{sellingPrice}} 购买完整报告</span>
      </button>
    </div> -->
    <!-- 下载 -->
    <!-- <button class="download" v-show="status == '2' && isWeiXin" @click="download">&nbsp;</button> -->
    <!-- <a class="download" v-show="status == '2' && !isWeiXin" :href="src" :download="productName" @click="downloadUrl">&nbsp;</a>
    <div class="download_mask_box" v-show="status == '2' && isShowMask">
      <img src="../../../assets/images/pay/mask_top.png" class="mask_top">
      <img src="../../../assets/images/pay/mask_btom.png" class="mask_btom">
      <button class="know" @click="close">知道了</button>
    </div> -->
    <!-- 跳转到成功页面使用 -->
    <!-- <p style="display: none;" ref="reportId">{{id}}</p>
    <p style="display: none;" ref="orderId">{{orderId}}</p>
    <p style="display: none;" ref="sellingPrice">{{sellingPrice}}</p>
    <p style="display: none;" ref="productName">{{productName}}</p> -->
  </div>
</template>

<script>
  import moment from 'moment'
  import pdf from 'vue-pdf'
  // import store from '@/store'
  // import { Toast } from 'vant';
  import { wxShare } from '@/helpers/wxconfig'
  // import { getOrder, createOrder, wechatPay, getPayInfo, getLogs } from '@/api/wechat'
  export default {
    components: {pdf},
    data() {
      return {
        pageCount:0,
        pdfUrl:'',
        src: this.$route.query.url, // pdf文件地址
        title: this.$route.query.title,
        numPages:0,
        loading: true,
        // id: this.$route.query.id,
        // status: this.$route.query.status, // 0 免费 1 已购 2 可查看30%
        // sellingPrice: 0,
        // productName: '',
        // productId: '',
        // orderId: '',
        // isShowMoney: false, // 是否显示购买按钮
        // isShowMask: false,
        // fileUrl: '',
        // isWeiXin: navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1 // 判断是否在微信浏览器打开
      }
    },
    mounted(){
      let meta = document.getElementsByTagName('meta');
      meta[name='viewport'].setAttribute('content',"width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes");
      document.title = this.title;
      // wxShare(this.title,'快来看看我分享的网站:'+this.title);
      wxShare(this.title,'这份报告质量很好，《'+this.title+'》，分享给您！');
      this.loadPdfHandler();
      // this.queryOrderInfo();
    },
    methods: {
      moment,
      async loadPdfHandler () {
        //src为你服务器上存放pdf的路径
        this.pdfUrl = await pdf.createLoadingTask(this.src);
        this.pdfUrl.promise.then(pdf => {
          this.loading = false;
          this.numPages = pdf.numPages;
        })
      },
      // 获取商品信息
      // queryOrderInfo(){
      //   // 每次都清空一次
      //   this.productId = '';
      //   let params = {
      //     productType: 1
      //   }
      //   getOrder(this.id, params).then(res => {
      //     if(res.data.status == 200){
      //       if(res.data.msg){
      //         this.productId = res.data.msg.id || '';
      //         this.sellingPrice = res.data.msg.sellingPrice || 0;
      //         this.productName = res.data.msg.name || '';
      //         this.isShowMoney = true;
      //       }else{
      //         this.productId = '';
      //       }
      //     }else{
      //       Toast({
      //         message: res.data.msg,
      //         duration: 1000,
      //       });
      //     }
      //   }).catch(err => {
      //     console.log(err);
      //   });
      // },
      // 生成订单
      // goPay(){
      //   // 每次都清空一次
      //   this.orderId = '';
      //   let args = JSON.parse(localStorage.getItem('wxdata'));
      //   if(this.productId  === ''){
      //     Toast({
      //       message: '商品信息productId错误',
      //       duration: 1000,
      //     });
      //     return false
      //   }
      //   let params = {
      //     productId: this.productId,
      //     appId: args.appId || '',
      //     userType: 0,
      //     type: 1 // 订单来源： 0 pc,1 公众号，2 安卓,3 iso
      //   }
      //   createOrder(params).then(res => {
      //     if(res.data.status == 200){
      //       this.orderId = res.data.orderId || '';
      //       this.toPay();
      //     }else{
      //       this.orderId = ''
      //       Toast({
      //         message: res.data.msg,
      //         duration: 1000,
      //       });
      //     }
      //   }).catch(err => {
      //     console.log(err);
      //   });
      // },
      // 发起支付
      // toPay(){
      //   console.log(this.orderId)
      //   if(this.orderId === ''){
      //     Toast({
      //       message: '商品信息orderId错误',
      //       duration: 1000,
      //     });
      //     return false
      //   }
      //   let params = {
      //     type: 1,  //  0 pc,1 公众号，2 安卓,3 iso
      //     appId: JSON.parse(localStorage.getItem('wxdata')).appId
      //   }
      //   wechatPay(this.orderId,params).then(res => {
      //     if(res.data.status == 200){
      //       if(res.data.msg){
      //         let args = res.data.msg;
      //         if (typeof WeixinJSBridge == "undefined"){
      //           if( document.addEventListener ){
      //             document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(args), false);
      //           }else if (document.attachEvent){
      //             document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(args));
      //             document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(args));
      //           }
      //         }else{
      //           this.onBridgeReady(args);
      //         }
      //       }
      //     }else{
      //       console.log('请求错误')
      //     }
      //   }).catch(err => {
      //     console.log(err);
      //   });
      // },
      // 支付
      // onBridgeReady(args){
      //   let _this = this;
      //   WeixinJSBridge.invoke(
      //     'getBrandWCPayRequest',
      //     {
      //       "appId": args.appId,     //公众号名称，由商户传入
      //       "timeStamp": args.timeStamp,         //时间戳，自1970年以来的秒数
      //       "nonceStr": args.nonceStr, //随机串
      //       "package": args.packAge,
      //       "signType": args.signType,         //微信签名方式：
      //       "paySign": args.paySign //微信签名
      //     },
      //     function (res) {
      //       if(res.err_msg == "get_brand_wcpay_request:ok" ) {
      //         _this.queryPayStatus();
      //       } else if (res.err_msg == "get_brand_wcpay_request:cancel" ) {
      //         Toast({
      //           message: '已取消支付',
      //           duration: 1000,
      //         });
      //         window.location.reload();
      //       } else if(res.err_msg == "get_brand_wcpay_request:fail"){
      //         Toast({
      //           message: '支付失败',
      //           duration: 1000,
      //         });
      //         WeixinJSBridge.call('closeWindow');
      //       }
      //     }
      //   );
      // },
      // // 查询支付状态
      // queryPayStatus(){
      //   let _this = this;
      //   // 清除一次
      //   this.fileUrl = '';
      //   let orderId = this.$refs.orderId.innerHTML,
      //       sellingPrice = this.$refs.sellingPrice.innerHTML,
      //       reportId = this.$refs.reportId.innerHTML,
      //       productName   = this.$refs.productName.innerHTML;
      //   let params = {
      //     openid: store.state.userInfo.openid,
      //     reportId: reportId
      //   }
      //   let count = 0;
      //   getPayInfo(orderId,params).then(res => {
      //     count++;
      //     if(res.data){
      //       if(res.data.status == '0'){
      //         let result = res.data.result.data;
      //         let id = result.id;
      //         this.fileUrl = result.allFileUrl;
      //         this.$router.push({
      //           path: 'paySuccess',
      //           query: {
      //             url: this.fileUrl,
      //             orderId: orderId,
      //             sellingPrice: sellingPrice,
      //             productName: productName,
      //             id: id
      //           }
      //         });
      //       }else{
      //         Toast({
      //           message: '支付失败',
      //           duration: 1000,
      //         });
      //         WeixinJSBridge.call('closeWindow');
      //       }
      //     }else{
      //       let time = null;
      //       if(count <= 2){
      //         //每隔1秒更新一下数据
      //         time = window.setInterval(() => {
      //           setTimeout(_this.queryPayStatus(), 0);
      //         },1000);
      //       }else{
      //         window.clearInterval(time);
      //       }
      //     }
      //   }).catch(err => {
      //     console.log(err);
      //   });
      // },
      // // 下载
      // download(){
      //   this.isShowMask = true;
      //   this.queryLogs('wechatdownload');
      // },
      close(){
        this.isShowMask = false;
      },
      // 下载文件
      // downloadUrl(){
      //   this.queryLogs('webdownload');
      // },
      // 下载日志收集
      // queryLogs(type){
      //   let data = {
      //     'page': this.$refs.productName.innerHTML,
      //     'type': type,
      //     'url': window.location.href,
      //     'conent': this.$refs.reportId.innerHTML
      //   }
      //   getLogs(data).then(res => {
      //     // console.log('不做任何处理');
      //   }).catch(err => {
      //     console.log(err);
      //   });
      // }
    }
  }
</script>
<style scoped>
 @import url("./detail.css");
</style>
